import { render, staticRenderFns } from "./Integer.vue?vue&type=template&id=71fb5074&scoped=true&"
import script from "./Integer.vue?vue&type=script&lang=js&"
export * from "./Integer.vue?vue&type=script&lang=js&"
import style0 from "./Integer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Integer.vue?vue&type=style&index=1&id=71fb5074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb5074",
  null
  
)

export default component.exports